import { submit as dynamicSearchSubmit } from "./dynamic-search.js";
import { getSearchBarOptions } from "./search-bar.js"
import { positionPickerPanel, updateUrlSearchParams } from "./pickers-init.js"
import { lockout, debounce } from "./utilities.js"

let prevFocus;
let destinationName;
let destinationValue;
let updateNeeded = false;
const activeClass = 'is-active';
const hiddenClass = 'is-hidden';
const mobileHiddenClass = 'c-pickers-panel__hide-mobile';
const $pickerBlock = $('#form-searchblock');
const $destinationPickerTrigger = $pickerBlock.find('.js-destination-picker-trigger');
const $destinationPanel = $pickerBlock.find('.js-destination-picker');
const isSearchResultsPage = $pickerBlock.hasClass('js-dynamic-search');
const panelIsOpen = () => $destinationPanel.hasClass(activeClass);
const closeAllPanels = () => {
	$pickerBlock.find('.c-pickers-panel').removeClass(activeClass);
	$pickerBlock.find('.js-date-picker-wrapper, .js-folks-selector-trigger, .js-airport-picker-trigger, .js-destination-picker-trigger').removeClass(activeClass);
}

function init() {
	attachEvents();
	updateDestinationList('MultiRoomUnavailable')
}

const removeCloseListener = (event) => {
	if (!event.target.closest('.js-destination-picker-facade, .js-destination-picker')) {
		closeDestinationPicker()
	}
}

function attachEvents() {

	$destinationPickerTrigger.on('click keypress', function(e) {
		if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
			if (panelIsOpen()) {
				closeAllPanels()
				closeDestinationPicker();
			}
			else {
				closeAllPanels()
				openDestinationPicker();
			}

			e.preventDefault();
		}
	});

	$pickerBlock.on('click', '.js-destination-picker-button', function(e) {
		handleButtonActivated($(this), true);
		e.preventDefault();
	});

	$pickerBlock.on('click', '.js-destination-picker-button-mobile', function(e) {
		handleMobileButtonClick($(this));
		e.preventDefault();
	});

	$pickerBlock.on('click', '.js-destination-picker-back', function() {
		const activeColumn = $destinationPanel.find('.js-destination-picker-col:visible');

		if (activeColumn.hasClass('js-destination-picker-regions')) {
			activeColumn.addClass(mobileHiddenClass);
			$destinationPanel.find('.js-destination-picker-countries').removeClass(mobileHiddenClass);
		}

		if (activeColumn.hasClass('js-destination-picker-subregions')) {
			activeColumn.addClass(mobileHiddenClass);
			$destinationPanel.find('.js-destination-picker-regions').removeClass(mobileHiddenClass);
		}

		setBackButtonDisplay();
	})

	$pickerBlock.on('click', '.js-destination-picker-apply, .js-destination-picker-close', function(e) {
		closeDestinationPicker();
	});

	window.site.body.on("pickersTabChange", function(e) {
		const roomType = e.multiroomType
		updateDestinationList(roomType)
	})

	const debounceBackButtonDisplay = debounce(setBackButtonDisplay, 150);
	window.site.win.on('resize', debounceBackButtonDisplay)
}

const updateDestinationList = (multiRoom) => {
	const destinations = multiRoom === "MultiRoomUnavailable" ? window.singleroomdestinations : window.multiroomdestinations;
	const countryCodes = destinations.Items.map(i => i.Value)

	// Bit of an ugly selector, but saves us doing filter().map() over the same elements
	$pickerBlock.find('.js-destination-picker-button-country[data-destination-value]:not([data-destination-value=""]').each(function(idx, button) {
		const buttonParent = button.closest('.c-destinations-picker__list-item');
		if (countryCodes.includes(button.dataset.destinationValue)) {
			buttonParent.classList.remove('hide')
		}
		else {
			//	buttonParent.classList.add('hide')
		}
	})
}

function setBackButtonDisplay() {
	const backButton = $destinationPanel.find('.js-destination-picker-back');

	if ($destinationPanel.find('.js-destination-picker-col:visible').hasClass('js-destination-picker-countries')) {
		backButton.addClass(mobileHiddenClass);
	}
	else {
		backButton.removeClass(mobileHiddenClass);
	}
}

function openDestinationPicker() {

	prevFocus = document.activeElement;
	lockout.on('tablet')
	window.site.win.on('resize', () => {
		positionPickerPanel($pickerBlock, $destinationPickerTrigger)
	});
	positionPickerPanel($pickerBlock, $destinationPickerTrigger)
	$pickerBlock.find('.js-destination-picker, .js-destination-picker-facade-container').addClass(activeClass);

	checkImageDisplay();
	setInitialMobileState();
	$destinationPanel.find('select, button, [href], input, [tabindex]:not([tabindex="-1"])').first().focus();

	window.requestAnimationFrame(() => {
		window.site.body.on('click.destination', (e) => removeCloseListener(e))
	})
}

function closeDestinationPicker() {

	if (updateNeeded) { // Destination can affect the Airport list even when not on Search Results page 
		getSearchBarOptions()
		if (isSearchResultsPage) {
			updateUrlSearchParams()
			dynamicSearchSubmit(false);
		}
		updateNeeded = false
	}

	$pickerBlock.find('.js-destination-picker, .js-destination-picker-facade-container').removeClass(activeClass);
	window.site.win.off('resize', () => {
		positionPickerPanel($pickerBlock, $destinationPickerTrigger)
	});

	window.site.body.off('click.destination')
	lockout.off()
	prevFocus?.focus();
}

function setInitialMobileState() {
	const selectedButton = $destinationPanel.find('.js-destination-picker-col .js-destination-picker-button.is-selected').first();
	$destinationPanel.find('.js-destination-picker-col').addClass(mobileHiddenClass);

	if (selectedButton.length) {
		// set columns
		selectedButton.closest('.js-destination-picker-col').removeClass(mobileHiddenClass);
		$destinationPanel.find('.c-destinations-picker__list:not(".js-destinations-picker-list-first")').removeClass(activeClass);
		selectedButton.closest('.c-destinations-picker__list').addClass(activeClass);
		selectedButton.addClass(activeClass);

		// reset the buttons
		$destinationPanel.find('.js-destination-picker-button').removeClass(activeClass);
		$destinationPanel.find('.js-destination-picker-button-mobile').removeClass(activeClass);
		selectedButton.addClass(activeClass);

		const region = selectedButton.closest('.c-destinations-picker__list').attr('data-destination-subregions-for-region');
		let country;

		if (region) {
			const regionButton = $destinationPanel.find('[data-destination-region="' + region + '"]');
			regionButton.addClass(activeClass);
			regionButton.closest('.js-destinations-picker-list-second-level').addClass(activeClass);
			country = regionButton.closest('.c-destinations-picker__list').attr('data-destination-regions-for-country');
		}

		if (country) {
			$destinationPanel.find('[data-destination-country="' + country + '"]:not(".js-destination-picker-button-mobile")').addClass(activeClass);
		}
	}
	else {
		$destinationPanel.find('.js-destination-picker-countries').removeClass(mobileHiddenClass);
	}

	setBackButtonDisplay();
}

function handleMobileButtonClick(trigger) {

	if (trigger.attr('data-destination-country')) {
		showRegionsForCountry(trigger.attr('data-destination-country'));
		$destinationPanel.find('.js-destination-picker-countries').addClass(mobileHiddenClass);
		$destinationPanel.find('.js-destination-picker-regions').removeClass(mobileHiddenClass);
	}

	if (trigger.attr('data-destination-region')) {
		showSubregionsForRegion(trigger.attr('data-destination-region'));
		$destinationPanel.find('.js-destination-picker-regions').addClass(mobileHiddenClass);
		$destinationPanel.find('.js-destination-picker-subregions').removeClass(mobileHiddenClass);
	}

	setBackButtonDisplay();
}

function handleButtonActivated(selectedButton) {
	const chosenDestination = selectedButton.text().trim();
	$pickerBlock.find('.js-destination-picker-facade').val(chosenDestination);

	if (destinationName !== chosenDestination) {
		updateNeeded = true;
		destinationName = chosenDestination;
		destinationValue = selectedButton.attr('data-destination-value');

		$pickerBlock.find('input[name="destination"]').val(destinationValue);
	}

	if ($pickerBlock.hasClass('js-dynamic-search')) {
		$pickerBlock.find('.js-destination-picker-facade').trigger('change'); // TODO what for?
	}

	$destinationPanel.find('.js-destination-picker-button').removeClass('is-selected');
	selectedButton.addClass('is-selected');

	if (selectedButton.hasClass('js-destination-picker-button-country')) {
		showRegionsForCountry(selectedButton.attr('data-destination-country'));
	}

	if (selectedButton.hasClass('js-destination-picker-button-region')) {
		showSubregionsForRegion(selectedButton.attr('data-destination-value'));
	}

	if (selectedButton.hasClass('js-destination-picker-button-sub-region')) {
		$destinationPanel.find('.js-destination-picker-button-sub-region').removeClass(activeClass);
		selectedButton.addClass(activeClass);
	}

	checkImageDisplay();
}

function showRegionsForCountry(country) {
	// show
	$destinationPanel.find('[data-destination-regions-for-country]').removeClass(activeClass);
	$destinationPanel.find('[data-destination-regions-for-country="' + country + '"]').addClass(activeClass);

	// toggle the buttons
	$destinationPanel.find('.js-destination-picker-button-region, .js-destination-picker-button-sub-region, .js-destination-picker-button-country, [data-destination-subregions-for-region]').removeClass(activeClass);
	$destinationPanel.find('.js-destination-picker-button[data-destination-value="' + country + '"]').addClass(activeClass);
}

function showSubregionsForRegion(region) {
	// show
	$destinationPanel.find('[data-destination-subregions-for-region]').removeClass(activeClass);
	$destinationPanel.find('[data-destination-subregions-for-region="' + region + '"]').addClass(activeClass);

	// toggle the buttons
	$destinationPanel.find('.js-destination-picker-button-sub-region, .js-destination-picker-button-region').removeClass(activeClass);
	$destinationPanel.find('.js-destination-picker-button[data-destination-value="' + region + '"]').addClass(activeClass);
}

function checkImageDisplay() {

	if (!$destinationPanel.find('.js-destinations-picker-list-second-level.is-active').length &&
		!$destinationPanel.find('.js-destinations-picker-list-third-level.is-active').length &&
		$destinationPanel.find('.js-destination-picker-image').length) {
		$destinationPanel.find('.js-destination-picker-col').not('.js-destination-picker-countries').addClass(hiddenClass);
		$destinationPanel.find('.c-destinations-picker__col--image').removeClass(hiddenClass);
	}
	else {
		$destinationPanel.find('.js-destination-picker-col').removeClass(hiddenClass);
		$destinationPanel.find('.c-destinations-picker__col--image').addClass(hiddenClass);
	}
}

export default init;

